import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Login = lazyWithPreload(() => import('./Login'))
export const WellhubLogin = lazyWithPreload(() => import('./WellhubLogin'))
